import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { LogOut } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { MaintenanceRequest } from "./request.ts";

/**
 * Classe para gerenciamento da página de perfil
 */
export class MaintenanceServices {
    constructor() {
        this.Requests = new MaintenanceRequest();
    }

    // Busca todas manutenções
    async getAllMaintenance(page, search, operators, equipments, cities, procedures, types, dataInicial, dataFinal){
        try {
            const response = await this.Requests.getAllMaintenance(page, search, operators, equipments, cities, procedures, types, dataInicial, dataFinal);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Busca os equipamentos para os filtros
    async getEquipments(){
        try {
            const response = await this.Requests.getEquipmentsFilter();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Busca as cidades para os filtros
    async getCities(){
        try {
            const response = await this.Requests.getCitiesFilter();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Buscar os usuários para os filtros
    async getOperators(){
        try {
            const response = await this.Requests.getOperatorsFilter();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Buscar os procedimentos para os filtros
    async getProcedures(){
        try {
            const response = await this.Requests.getProceduresFilter();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Busca uma manutenção pelo id
    async getMaintenanceById(id){
        try {
            const response = await this.Requests.getMaintenanceById(id);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return null;
        }
    }

    // busca o report de manutenção
    async GetMaintenanceReports(dataFinal, dataInicial){
        try {
            dataFinal = this.getData(new Date(dataFinal));
            dataInicial = this.getData(new Date(dataInicial));
            let response = await this.Requests.GetMaintenanceReports(dataInicial + '/' + dataFinal);
            response.length > 0 ? response = await this.formatStats(response) : response = [];
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Formata os dados do report
    async formatStats(dataStats){
        try {
            let data = [];
            data.push({
                id: "Manutenção Corretiva",
                label: "Manutenção Corretiva",
                value: dataStats[0][0],
            });
            data.push({
                id: "Manutenção Preventiva",
                label: "Manutenção Preventiva",
                value: dataStats[0][1],
            });
            dataStats[0] = data;
            return dataStats;
        } catch (error) {
            return [];
        }
    }

    getData(data){
        let dia = (data.getDate()).toString();
        let mes = (data.getMonth() + 1).toString();
        let ano  = (data.getFullYear()).toString();
        mes = mes.length < 2 ? '0' + mes : mes;
        dia = dia.length < 2 ? '0' + dia : dia;
        data = [ano, mes, dia].join('-');
        return data.toString();
    }
}